<!-- Modal -->
<div class="modal fade" [id]="id" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" id="modalLabel">{{header}}</div>
        <button type="button" class="close" aria-label="Close" (click)="proceedCancel()">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body" style="height:600px;overflow-y:scroll;overflow-x:hidden;" id="divTc">
          <cli-terms-and-conditions></cli-terms-and-conditions>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="proceedYes()">Close</button>
      </div>
    </div>
  </div>
</div>